<template>
  <div>
    <div class="card no-border widget-loader-circle no-padding rounded">
      <div class="card-header">
      </div>
      <div class="card-body p-t-20 p-b-30">
        <div class="card-icon">
        </div>

        <div class="card-link">
          <a class="sectiontitle2 text-24-gray">{{ $t('survey_statistics') }}</a>
        </div>

        <div class="open-survey-text p-t-10 p-b-10">
          <div class="survey-intro">
            <p>{{ username }}</p>
          </div>
        </div>

        <table class="table table-borderless stat-table">
          <tbody>
          <tr v-for="stat in stats">
            <td>{{ stat.Key }}</td>
            <td class="stat-output">{{ stat.Value }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['username', 'stats'],
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/home/Statistics.vue